<template>
    <div>
        <p class="text-small text-primary font-weight-medium mb-3">
            <v-icon class="me-2" color="secondary" size="20">icon-dash</v-icon>دسته‌بندی موضوعی تیکت‌ها
        </p>
        <v-skeleton-loader v-if="skeleton" class="mx-auto" height="350" type="ossein"></v-skeleton-loader>
        <apexchart
            :options="chartOptions"
            :series="series"
            height="350"
            v-else
        ></apexchart>
    </div>
</template>
<script>
import fa from "apexcharts/dist/locales/fa.json";
import VueApexCharts from "vue3-apexcharts";
export default {
    components: {
        apexchart: VueApexCharts,
    },
    props: {
    },
    data() {
        return {
            skeleton: true,
            series: [],
            chartOptions: {
                chart: {
                    locales: [fa],
                    defaultLocale: "fa",
                    stacked: true,
                    type: "treemap"
                },
                legend: {
                    show: false,
                },
                tooltip: {
                    style: {
                        fontFamily: "iransans",
                    },
                },
                dataLabels: {
                    style: {
                        fontFamily: "iransans",
                    },
                },
            },
            search:{},
        };
    },
    methods: {
        reportTicketCategoryFilter(search) {
            this.skeleton = true;
            this.search = {...search}
            this.reportTicketCategoryGet();
        },
        reportTicketCategoryGet() {
            this.$reportTicketCategoryTicket(this.search).then((res) => {
                if (res && res.status == "OK") {
                    this.series = [];
                    this.series.push({
                        data: res.data.filter(Boolean),
                    });
                    this.skeleton = false;
                }
            });
        },
    },
    mounted() {
        this.reportTicketCategoryGet();
    },
};
</script>
